import { css } from "@emotion/react";

export const carouselItem = css`
  width: 100%;
  height: 100%;
  display: flex;
`;
